var _rect, _rect2, _rect3, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeplrLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    width: 84,
    height: 84,
    rx: 20.4458,
    transform: "rotate(90 84 0)",
    fill: "url(#paint0_linear_107_742)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 84,
    width: 84,
    height: 84,
    rx: 20.4458,
    transform: "rotate(90 84 0)",
    fill: "url(#paint1_linear_107_742)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: -0.0000152588,
    y: 0.0000610352,
    width: 84,
    height: 84,
    rx: 20.4458,
    fill: "url(#paint2_linear_107_742)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1765 63.9361V44.5068L52.439 63.9361H62.5987V63.4347L41.5937 41.3104L60.9781 20.3142V20.0635H50.7561L34.1765 38.6154V20.0635H25.949V63.9361H34.1765Z",
    fill: "url(#paint3_linear_107_742)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_742",
    x1: 130.146,
    y1: -2.94268,
    x2: 81.4586,
    y2: 93.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.210712,
    stopColor: "#457CD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681753,
    stopColor: "#58ADE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943139,
    stopColor: "#71C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_742",
    x1: 87.4777,
    y1: 48.0191,
    x2: 159.172,
    y2: 74.1019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457CD6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#58ADE9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570545,
    stopColor: "#AF75EA",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8557E8",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_107_742",
    x1: -0.000018704,
    y1: -1.73879,
    x2: 84,
    y2: 80.9236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0688789,
    stopColor: "#457CD6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#58ADE9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466157,
    stopColor: "#B594FB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634398,
    stopColor: "#D483FB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899464,
    stopColor: "#BE6CFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B969F8",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_107_742",
    x1: 44.2739,
    y1: 20.0635,
    x2: 44.2739,
    y2: 63.9361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeplrLogo);
export default __webpack_public_path__ + "static/media/keplr-logo.a0b27a9c516d7d9852d784956f2a6411.svg";
export { ForwardRef as ReactComponent };